import { Box, type Colors, Tag, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

interface Props {
  label: string
  onChange: (value: string) => void
  archived: boolean
  draft: boolean
}

const ArchivedTag = ({ archived }: { archived: boolean }) => {
  if (!archived) return null

  return (
    <Tag type={Tag.Types.grey}>
      {i18n.t('settings.legal_entities.legal_entity.contracts.modal.options.archived')}
    </Tag>
  )
}

const Item = ({ archived, color, label }: { archived: boolean; color: Colors; label: string }) => {
  return (
    <Box
      background="grey200"
      padding="s12"
      flexGrow
      borderRadius={{
        all: 'abs004',
      }}
      flexDirection="row"
      height="s48"
    >
      <Text.Normal color={color}>{label}</Text.Normal>
      <Box paddingLeft="s16" inline>
        <ArchivedTag archived={archived} />
      </Box>
    </Box>
  )
}

const ModalOptionInput = ({ label, onChange, archived, draft }: Props) => {
  if (draft) {
    return (
      <TextField
        value={label}
        placeholder={i18n.t(
          'settings.legal_entities.legal_entity.contracts.modal.options.placeholder'
        )}
        onChange={onChange}
      />
    )
  }

  const color = archived ? 'grey800' : 'grey1000'

  return <Item archived={archived} color={color} label={label} />
}

export default observer(ModalOptionInput)
